import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { StandardDialog } from "../dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "2rem",
        paddingTop: "1rem",
    },
    description: {
        color: theme.palette.text.primary,
        textAlign: "center",
    },
}))

type ProductUnavailableDialogProps = Readonly<{
    open: boolean
    onClose: () => void
    title: string
    message: string
}>

export function ProductUnavailableDialog({ open, onClose, title, message }: ProductUnavailableDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog open={open} onClose={onClose} dialogTitle={title} maxWidthProp="sm">
            <Box className={classes.container}>
                <Typography variant="body1" className={classes.description}>
                    {message}
                </Typography>
            </Box>
        </StandardDialog>
    )
}
